import { get, post, put, repositoryApi, vdbsPublicApi, getToken } from '../utilities/apiUtilities';

export const postUser = (data) => post({
  url: `${repositoryApi}/users`,
  data,
});

export const putUser = (data) => put({
  url: `${repositoryApi}/users`,
  data,
});

export const getUsers = (params) => get({
  url: `${repositoryApi}/users`,
  params,
});

export const getUser = (id) => get({
  url: `${repositoryApi}/users/${id}`,
});

const isAnonymousToken = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.roles && payload.roles.includes('ROLE_ANONYMOUS');
  } catch {
    return false;
  }
};

export const getCurrentUser = () => {
  const baseUrl = isAnonymousToken() ? `${vdbsPublicApi}/jflow/repository-api/v0.0.1` : repositoryApi;
  return get({
    url: `${baseUrl}/user`,
  });
};
